import React from "react";

function TermsCondition() {
  return (
    <div style={{margin : '10px' , fontWeight : '500'}}>
      <h1>Terms and Conditions</h1>
      <h2>1. Introduction</h2>
      <p>
        Welcome to Tiny URL. These Terms and Conditions "Terms" govern your use
        of our website and our URL shortening services. By accessing or using
        our services, you agree to be bound by these Terms. If you do not agree
        to these Terms, you should not use our services.
      </p>
      <h2>2. Use of Our Services</h2>
      <p>
        Eligibility: You must be at least 13 years old to use our services. By
        using our services, you represent and warrant that you meet this
        eligibility requirement.
      </p>
      <p>
        Account Registration: To use certain features of our services, you may
        need to register for an account. You agree to provide accurate, current,
        and complete information during the registration process and to update
        such information to keep it accurate, current, and complete.
      </p>
      <p>
        Prohibited Activities: You agree not to use our services for any
        unlawful or prohibited purpose. You shall not:
      </p>
      <ul>
        <li>
          Use our services to create, transmit, or distribute any unsolicited
          commercial communications (spam).
        </li>
        <li>
          Use our services to distribute malware, viruses, or other harmful
          code.
        </li>
        <li>
          Attempt to gain unauthorized access to our services or its related
          systems or networks.
        </li>
        <li>
          Use our services in a manner that could damage, disable, overburden,
          or impair our servers or networks.
        </li>
      </ul>
      <h3>3. User Content</h3>
      <p>
        Responsibility: You are solely responsible for any content you create,
        shorten, or distribute using our services. We do not endorse any content
        created by users and expressly disclaim any and all liability in
        connection with user content.
      </p>
      <p>
        Monitoring and Enforcement: We reserve the right, but are not obligated,
        to monitor, review, or edit user content. We may remove or disable
        access to any user content that violates these Terms or applicable laws.
      </p>
      <h3>4. Intellectual Property</h3>
      <p>
        Our Content: All content on our website and services, including text,
        graphics, logos, and software, is the property of Tiny URl or its
        content suppliers and is protected by copyright, trademark, and other
        laws
      </p>
      <p>
        User Content: You retain ownership of any content you submit, post, or
        display on or through our services. By submitting, posting, or
        displaying content on or through our services, you grant us a worldwide,
        non-exclusive, royalty-free license to use, copy, reproduce, process,
        adapt, modify, publish, transmit, display, and distribute such content
        in any and all media or distribution methods.
      </p>
      <h3>5. Termination</h3>
      <p>
        We may terminate or suspend your access to our services immediately,
        without prior notice or liability, for any reason, including if you
        breach these Terms. Upon termination, your right to use our services
        will immediately cease.
      </p>
      <h3>6. Limitation of Liability</h3>
      <p>
        To the fullest extent permitted by applicable law,<b>Tiny URL</b> shall
        not be liable for any indirect, incidental, special, consequential, or
        punitive damages, or any loss of profits or revenues, whether incurred
        directly or indirectly, or any loss of data, use, goodwill, or other
        intangible losses, resulting from (i) your use or inability to use our
        services; (ii) any unauthorized access to or use of our servers and/or
        any personal information stored therein; (iii) any interruption or
        cessation of transmission to or from our services; (iv) any bugs,
        viruses, trojan horses, or the like that may be transmitted to or
        through our services by any third party; (v) any errors or omissions in
        any content or for any loss or damage incurred as a result of your use
        of any content posted, emailed, transmitted, or otherwise made available
        through our services.
      </p>
      <h3>8. Changes to These Terms</h3>
      <p>We reserve the right to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.</p>
      <h3>9. Contact Us</h3>
      <p></p>
    </div>
  );
}

export default TermsCondition;
